module.exports = __webpack_public_path__ + "img/bg-404.58eb48ed.png";